module.exports = __webpack_public_path__ + "static/media/password-strength-zwak.97b21aed.svg";